import { DateTime } from 'luxon'

export const END_OF_DAY_MINUTES = 24 * 60

export function isMidnightEndTimeStr (timeStr) {
  if (timeStr === null || timeStr === undefined || timeStr === '') {
    return false
  }
  const str = String(timeStr)
  return str === '0' || str === '0.00' || str === '0.0' || str === '24.00' || str === '24.0'
}

export function timeToMinutes (timeStr) {
  if (timeStr === null || timeStr === undefined || timeStr === '') {
    return null
  }
  const dt = DateTime.fromFormat(String(timeStr), 'H.mm')
  if (!dt.isValid) {
    return null
  }
  return dt.hour * 60 + dt.minute
}

export function endTimeToMinutes (timeStr) {
  if (timeStr === null || timeStr === undefined || timeStr === '') {
    return null
  }
  if (isMidnightEndTimeStr(timeStr)) {
    return END_OF_DAY_MINUTES
  }
  return timeToMinutes(timeStr)
}

export function isMidnightEndTime (timeObj) {
  if (!timeObj) {
    return false
  }
  return timeObj.hours === 0 && timeObj.minutes === 0
}

export function endTimeToMinutesFromObject (timeObj) {
  if (!timeObj) {
    return null
  }
  if (isMidnightEndTime(timeObj)) {
    return END_OF_DAY_MINUTES
  }
  return timeObj.hours * 60 + timeObj.minutes
}

export function isPricerowTimerangeValid (timestart, timeend) {
  const startMinutes = timeToMinutes(timestart)
  const endMinutes = endTimeToMinutes(timeend)
  if (startMinutes === null || endMinutes === null) {
    return true
  }
  return startMinutes < endMinutes
}

export function pricerowTimeToObject (timeStr) {
  if (timeStr === null || timeStr === undefined || timeStr === '') {
    return null
  }
  const str = String(timeStr)
  if (str === '24.00' || str === '24.0') {
    return { hours: 0, minutes: 0, seconds: 0 }
  }
  const dt = DateTime.fromFormat(str, 'H.mm')
  if (!dt.isValid) {
    return null
  }
  return {
    hours: dt.hour,
    minutes: dt.minute,
    seconds: 0
  }
}
